import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CURRENCY_LABEL, CustomEvents, DEFAULT_PRECISION, FREE_PLAN_LEVEL, Utils } from '@app/_helpers';
import { EventsService } from '@app/_shared/providers';
import { FundsService } from '@app/_shared/providers/funds/funds.service';
import { ALLOCATION_TEXT, AUTO_PAY_DISABLED_ON_RESTRICTED_PLAN_SUBSCRIPTION, AUTO_PAY_INFO, COUPON_FOR_ONLY_NEW_USERS, COUPON_UTM_MISMATCH, DOWNGRADE_ALERT, DOWNGRADE_CONFIRMATION, INVALID_COUPON_PLACEHOLDER, UPGRADE_INFO_TOOLTIP, WITHDRAWAL_MARGIN_FORMULA, getNegativeFundString } from '@app/_shared/strings';
import { planOrderDetailSummary } from '@app/modules/admin/components/payment-configurations/payment-configurations.interface';
import { PaymentConfigurationsService } from '@app/modules/admin/providers/payment-configurations/payment-configurations.service';
import { CouponDetails } from '@app/modules/admin/providers/plan-n-pricing/plan-n-pricing.interfaces';
import { PRODUCT_ID } from '@app/modules/trading/modules/profile/components/funds/funds.enums';
import { ChargeBeeHandler } from '@app/modules/trading/modules/profile/components/plans/chargebee.service';
import { DiscountType, PaymentGateway, PaymentMode, PlanActions } from '@app/modules/trading/modules/profile/components/plans/plans.enums';
import { BrokerPlanDetails } from '@app/modules/trading/modules/profile/components/plans/plans.interface';
import { PersonalDetailsService } from '@app/modules/trading/modules/profile/providers/personal-details/personal-details.service';
import { WebErrorCodes } from '../../../../utProto/webEnums_pb';
import { ConfirmationDialogService } from '../confirmation-dialog';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';
import { CANCEL_BUTTON_TEXT, CONFIRM_BUTTON_TEXT } from '@app/_helpers/confirmation-dialog.enums';

@Component({
  selector: 'app-broker-plan-payment-options',
  templateUrl: './broker-plan-payment-options.component.html',
  styleUrls: ['./broker-plan-payment-options.component.scss']
})


export class BrokerPlanPaymentOptionsComponent implements OnInit {
  CURRENCY_LABEL = CURRENCY_LABEL;
  isBillingDetailExpanded = false;
  isBalanceSummmaryExpanded = false;
  availableFunds: number = 0;
  hideChangePlan = true;
  AUTO_PAY_INFO = AUTO_PAY_INFO;
  isAutoPayOn: boolean = false;
  downgradablePlan: boolean = false;
  planOrderSummary: planOrderDetailSummary;
  planOrderSummaryAfterDiscount: planOrderDetailSummary;
  DEFAULT_PRECISION = DEFAULT_PRECISION;
  WITHDRAWAL_MARGIN_FORMULA: string =  WITHDRAWAL_MARGIN_FORMULA;
  ALLOCATION_TEXT: string = ALLOCATION_TEXT;
  UPGRADE_INFO_TOOLTIP: string = UPGRADE_INFO_TOOLTIP;
  showUpgradeInfoTooltip: boolean = false;
  NEGATIVE_FUND_STRING: string;
  couponApplied: boolean = false;
  isCouponValid: boolean = false;
  invalidCouponError:string = INVALID_COUPON_PLACEHOLDER;
  DOWNGRADE_CONFIRMATION: string = DOWNGRADE_CONFIRMATION;
  DOWNGRADE_ALERT: string = DOWNGRADE_ALERT;
  AUTO_PAY_DISABLED_ON_RESTRICTED_PLAN_SUBSCRIPTION = AUTO_PAY_DISABLED_ON_RESTRICTED_PLAN_SUBSCRIPTION;
  couponDetails: CouponDetails;
  DiscountType = DiscountType;
  discountForm: UntypedFormGroup;
  hasNegativeFunds: boolean = false;
  expandDiscountExpansionPanel: boolean = false;
  specialCouponCodeApplied: boolean = false;
  isExclusiveCoupon = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public planData: BrokerPlanDetails,
    private dialogRef: MatDialogRef<BrokerPlanPaymentOptionsComponent>,
    private chargeBeeService: ChargeBeeHandler,
    private fundsService: FundsService,
    private paymentConfigurationsService: PaymentConfigurationsService,
    private personalDetailsService: PersonalDetailsService,
    private confirmationService: ConfirmationDialogService,
    public eventService: EventsService,
    private mbPlansService: MbPlansService,
  ) {
    this.hideChangePlan = !!planData.isPromotePlan;
    this.isAutoPayOn = !planData.isAutopayOff;
    this.downgradablePlan = planData.downgradablePlan;
    this.discountForm = new UntypedFormGroup({
      discountCoupon: new UntypedFormControl('', [Validators.required])
    });
  }

  ngOnInit(): void {
    this.paymentConfigurationsService
      .getPlanOrderSummary(this.planData.id)
      .subscribe((res) => {
        this.planOrderSummary = res;
        this.planOrderSummaryAfterDiscount = res;
        this.getMargin(this.planOrderSummary);
      });
    this.checkPlanFrequencyToolTip();
  }

  getMargin(planOrderSummary: planOrderDetailSummary) {
    this.fundsService.fetchMargin().subscribe(res => {
      const response = res.response;
      if (response.length) {
        response.forEach((data) => {
          if (data.product_id === PRODUCT_ID.ALL) {
            this.availableFunds = (data.withdrawable_margin && data.withdrawable_margin > 0) ? data.withdrawable_margin : Utils.withdrawMarginLimit(data);
          }
        })
      }

      if (!this.planData.is_approval_required_plan) {
        // const special_coupon_code = this.personalDetailsService.planCache.special_coupon_code;
        // if (special_coupon_code && !this.downgradablePlan) {
        //   this.expandDiscountExpansionPanel = true;
        //   this.paymentConfigurationsService.getCouponDetails(special_coupon_code).subscribe((res) => {
        //     //array containing plan ids in which special coupon is invalid.
        //     const invalid_on_plan_ids = res.invalid_valid_on_plan_ids;
        //     if(!invalid_on_plan_ids?.includes(this.planData.id)){
        //       this.discountForm.get('discountCoupon').setValue(special_coupon_code);
        //       this.applyDiscount();
        //     }
        //   });
        // }
      } else if (this.planData.coupon_ids && this.planData.coupon_ids.length) {
        this.discountForm.get('discountCoupon').setValue(this.planData.coupon_ids[0]);
        this.applyDiscount(true);
      } 
      if (response.length) {
        response.forEach((data) => {
          if (data.product_id === PRODUCT_ID.ALL && 
            !(this.specialCouponCodeApplied || 
              (this.planData.coupon_ids && this.planData.coupon_ids.length))) {
            this.isBalanceSummmaryExpanded = !this.isBalanceSufficient(planOrderSummary);
          }
        })
      }

    }, _ => {
      if (this.planData.coupon_ids && this.planData.coupon_ids.length) {
        this.discountForm.get('discountCoupon').setValue(this.planData.coupon_ids[0]);
        this.applyDiscount();
      } else {
        this.isBalanceSummmaryExpanded = !this.isBalanceSufficient(planOrderSummary);
      }
    })
  }

  redirectToAddFunds() {
      // Redirect to Retail Add Funds Page
      this.fundsService.getPayinUrl(this.hideChangePlan ? false : true).subscribe(res => {
        let authLink = res.link;
        authLink = Utils.addParamToStringUrl(authLink, 'VIEW_PLATFORM', 'WEB');
        location.assign(authLink);
      });
  }

  subscribePlan() {
    if ((this.downgradablePlan && !this.isAutoPayOn) && (!this.planData.isPromotePlan)) {
      const params = Utils.confirmationDialogParams(DOWNGRADE_ALERT, undefined, undefined, CANCEL_BUTTON_TEXT.close, CONFIRM_BUTTON_TEXT.changeAutopay);
      this.confirmationService.alert(params);
    } else {
      if (this.planData.label !== PlanActions.DOWNGRADE) {
        this.eventService.publish(CustomEvents.PaymentResult, this.planData.brokerage_value);
      }
      this.chargeBeeService.submitPayment(
        this.planData.id,
        '',
        PaymentMode.CARD,
        PaymentGateway.STRIPE,
        !this.isAutoPayOn,
        (this.isCouponValid)? this.discountForm.get('discountCoupon').value: ''
      ).subscribe((_) => {
        this.dialogRef.close({ success: true });
        this.mbPlansService.isCurrentPlanOneTime = this.planData.isRestrictedPlan || false;
      }, _ => {
        this.getMargin(this.planOrderSummaryAfterDiscount);
      })
    }
  }

  closeDialog() {
    this.dialogRef.close({ success: false });
  }

  applyDiscount(isExclusiveCoupon: boolean = false) {
    const discountCoupon = this.discountForm.get('discountCoupon').value;
    this.paymentConfigurationsService.getDiscountedPlanOrderSummary(this.planData.id, discountCoupon).subscribe((res) => {
      this.isExclusiveCoupon = isExclusiveCoupon;
      this.couponApplied = true;
      this.expandDiscountExpansionPanel = true;
      if (res.estimate) {
        this.planOrderSummaryAfterDiscount = res;
        this.isCouponValid = true;
        this.discountForm.get('discountCoupon').disable();
        this.paymentConfigurationsService.getCouponDetails(discountCoupon).subscribe((res) => {
          if (this.planOrderSummaryAfterDiscount?.estimate?.discount_value !== res.discount_value) {
            this.hasNegativeFunds = true;
            this.NEGATIVE_FUND_STRING = getNegativeFundString(res.discount_value, this.planOrderSummaryAfterDiscount?.estimate?.discount_value);
          } else {
            this.hasNegativeFunds = false;
          }
          this.couponDetails = res;
        })
      } else {
        this.planOrderSummaryAfterDiscount = this.planOrderSummary;
        if (res.error_code === WebErrorCodes.WEBERRORCODES_COUPONFORONLYNEWUSERS) {
          this.invalidCouponError = COUPON_FOR_ONLY_NEW_USERS;
        } else if (res.error_code === WebErrorCodes.WEBERRORCODES_COUPONUTMMISMATCH) {
          this.invalidCouponError = COUPON_UTM_MISMATCH;
        } else {
          this.invalidCouponError = INVALID_COUPON_PLACEHOLDER;
        }

        this.isCouponValid = false;
      }
      this.isBalanceSummmaryExpanded = !this.isBalanceSufficient(this.planOrderSummaryAfterDiscount);
    }, _ => {
      this.isBalanceSummmaryExpanded = !this.isBalanceSufficient(this.planOrderSummaryAfterDiscount);
    })
  }

  removeDiscount() {
    this.couponApplied = false;
    this.isExclusiveCoupon = false;
    this.discountForm.get('discountCoupon').enable();
    this.planOrderSummaryAfterDiscount = this.planOrderSummary;
    this.isBalanceSummmaryExpanded = !this.isBalanceSufficient(this.planOrderSummaryAfterDiscount);
    this.discountForm.get('discountCoupon').setValue('');
  }

  isBalanceSufficient(planOrderSummary: planOrderDetailSummary) {
    const requiredFunds = parseFloat(Utils.precisionUtil(planOrderSummary?.estimate?.amount_due, DEFAULT_PRECISION));
    return this.availableFunds >= requiredFunds;
  }

  checkPlanFrequencyToolTip() {
    let currentPlan = this.mbPlansService.currentPlan.plan;
    let newPlan = this.planData;
    // The tooltip will be displayed on the checks that the plan should have label "Upgrade Plan"
    // and should be in same billing cycle (frequency and duration) and the current plan should not 
    // be a free plan .
    if ((newPlan.frequency === currentPlan.frequency) && (newPlan.duration === currentPlan.duration) &&
      (newPlan.label === PlanActions.UPGRADE) && (currentPlan.level !== FREE_PLAN_LEVEL)) {
        this.showUpgradeInfoTooltip = true;
    }
    else {
      this.showUpgradeInfoTooltip = false;
    }
  }

}
